/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
import pako from 'pako';
import CryptoJS from 'crypto-js';
import columnDefs from '../../column-defs';

export const getBorderColor = (id, str = 'remove') => {
  if (document.querySelector(`.Node_${id}`)) {
    const styleProp = document.querySelector(`.Node_${id}`).closest('.react-flow__node');
    styleProp.style.setProperty('border', (str && str === 'add') ? '' : '1px solid #ddd', (str && str === 'add') ? '' : 'important');
  }
};

export const removeCrossIcon = (item) => {
  if (item.id.indexOf('mixsplit_') >= 0) {
    getBorderColor(item.id);
    if (document.querySelector(`.Node_${item.id}`)) {
      document.querySelector(`.Node_${item.id}`)
        .closest('.custom-node-element')
        .querySelector('.unitop-close-icon-div')
        .classList.add('hide');
      document.querySelector(`.Node_${item.id}`)
        .closest('.react-flow__node').classList.add('disabled');
    }
  }
};

const getLocalPath = () => {
  if (window) {
    return window.location.origin;
  }
  return '';
};

export const toStartCase = (text = '') => {
  if (!text) return '';
  const result = text.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const getColumnDefs = (path) => {
  if (path instanceof Array) return path.map((data) => columnDefs[data]);
  return columnDefs[path];
};

export const getMail = async () => {
  // const getUserDetails = await cognitoUtils.getCognitoSession();
  const getUserMail = sessionStorage.getItem('user_email'); // getUserDetails.user.email;
  return getUserMail;
};

export const textFormatter = (text) => {
  if (!text) return '';
  if (text.length > 15) {
    return `${text.slice(0, 15)}...`;
  }
  return text;

};

export const encrypt_data = (data) => {
  let key = process.env.REACT_APP_SECRET_KEY; // 'ewfWE@#%$rfdsefg';
  let salt = process.env.REACT_APP_SALT_KEY; // 'ABCDEFGHIJKLMNOP';
  const str = JSON.stringify(data);
  salt = CryptoJS.enc.Utf8.parse(salt);
  key = CryptoJS.enc.Utf8.parse(key);

  const options = {
    iv: salt,
    padding: CryptoJS.pad.NoPadding,
    mode: CryptoJS.mode.CFB,
  };
  const cipher = CryptoJS.AES.encrypt(str, key, options);
  const cipher_new = cipher.ciphertext.toString(CryptoJS.enc.Base64);
  return cipher_new;
};

export const decrypt_data = (encData) => {
  let key = process.env.REACT_APP_SECRET_KEY; // 'ewfWE@#%$rfdsefg';
  let salt = process.env.REACT_APP_SALT_KEY; // 'ABCDEFGHIJKLMNOP';
  // const str = response.data;
  salt = CryptoJS.enc.Utf8.parse(salt);
  key = CryptoJS.enc.Utf8.parse(key);
  const options = {
    iv: salt,
    padding: CryptoJS.pad.NoPadding,
    mode: CryptoJS.mode.CFB,
  };
  const cipher = CryptoJS.AES.decrypt(encData, key, options);
  const decryptedtext = cipher.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedtext);
};
/**
 * when user click on download button to download a file using `downloadFlowSheetJSON`
 * added by chandrashekhar to download win file encrypted form
 * GB-2998 `Winfile should be encrypted on downloading, saving and decrypted on file opening`
 */

export const downloadFlowSheetJSON = (FlowData, text) => {
  let jsonString = JSON.stringify(FlowData);
  jsonString = encrypt_data(jsonString);
  const blob = new Blob([jsonString], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url; // eslint-disable-next-line
  link.download = `${text}.win`; // creating file name
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const decompressedData_with_decrypt = (data) => {

  const compressedData = JSON.parse(data).compressed_data;

  const compressedDataUint8Array = Uint8Array.from(atob(compressedData), c => c.charCodeAt(0));

  let decompressedData;
  try {
    decompressedData = pako.inflate(compressedDataUint8Array, { to: 'string' });
  } catch (err) {
    console.error('Error decompressing data:', err);
  }

  // decrypt data
  const ans = decrypt_data(decompressedData);
  return ans;
};

export default getLocalPath;
